import { ApolloClient } from "@apollo/client";
import {
  DepartureListDocument,
  DepartureListInput,
} from "../../../../gen/graphql/types";

export const getDepartureCsvDownloadData = async (
  input: DepartureListInput,
  client: ApolloClient<object>
) => {
  const { data } = await client.query({
    query: DepartureListDocument,
    variables: { input },
    fetchPolicy: "network-only",
  });

  return data;
};
